import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

const LocationDetailCard = ({ className, name }) => (
  <Card className={cn(className, 'pa3')}>
    <div>
      <h3 className="f4 mt0">{name}</h3>
    </div>
  </Card>
);

export default LocationDetailCard;



// WEBPACK FOOTER //
// ./src/components/locationDetailCard/locationDetailCard.jsx